import script from "./StickerPrinter.vue?vue&type=script&setup=true&lang=js"
export * from "./StickerPrinter.vue?vue&type=script&setup=true&lang=js"

import "./StickerPrinter.vue?vue&type=style&index=0&id=0c4b49b6&lang=css"

const __exports__ = script;

export default __exports__